import { useSubmit } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ReferenceCheckTemplatePageLayout } from "../ReferenceCheckTemplatePageLayout";
import { useReferenceCheckTemplatesContext } from "../ReferenceCheckTemplatesContext";
import {
  PersonalQuestionsSection,
  ProfessionalQuestionsSection,
} from "../../ReferenceCheckTemplateForm";
import {
  apiFailureMessage,
  type ReferenceCheckTemplateFormValues,
  validationSchema,
} from "../../utils";

export function ReferenceCheckTemplateQuestionsStep() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { template } = useReferenceCheckTemplatesContext();

  const goBack = () => navigate("/settings/reference-check-templates");

  const { submit } = useSubmit(
    "/api/internal/client-portal/check-arguments-templates/reference/create/",
    {
      showToastOnError: false,
      onSuccess: () => {
        showToast(t("Template created successfully!"), { type: "success" });
        goBack();
      },
      onFailure: (error) => {
        const base = t("Something went wrong");
        const detail = apiFailureMessage(error);
        showToast(detail ? `${base}: ${detail}` : base, { type: "error" });
      },
    }
  );

  return (
    <Formik<ReferenceCheckTemplateFormValues>
      initialValues={template}
      validationSchema={validationSchema()}
      validateOnMount
      onSubmit={(values) =>
        submit({
          name: values.name,
          check_arguments: {
            professional_quantity: values.professional_quantity,
            personal_quantity: values.personal_quantity,
            professional_questions:
              values.professional_quantity > 0
                ? values.professional_questions
                : [],
            personal_questions:
              values.personal_quantity > 0 ? values.personal_questions : [],
            ...(values.custom_instructions
              ? { custom_instructions: values.custom_instructions }
              : {}),
          },
        })
      }
    >
      {({ values, handleSubmit, isSubmitting, isValid }) => (
        <ReferenceCheckTemplatePageLayout
          onComplete={handleSubmit}
          submitting={isSubmitting}
          disableCompletion={!isValid}
        >
          <ProfessionalQuestionsSection values={values} />
          <PersonalQuestionsSection values={values} />
        </ReferenceCheckTemplatePageLayout>
      )}
    </Formik>
  );
}
